// Number formatting utility — executive enterprise-grade short notation.
// Examples:
//   2200666.61  → "2.2M"
//   142000      → "142K"
//   0.942       → "94.2%"  (with format(v, { percent: true }))
//   38          → "38"
// Currency variant appends " SAR" (or before in AR).

export function compact(n, { decimals = 1 } = {}) {
  if (n === null || n === undefined || isNaN(n)) return '—';
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) return (n / 1_000_000_000).toFixed(decimals).replace(/\.0$/, '') + 'B';
  if (abs >= 1_000_000)     return (n / 1_000_000).toFixed(decimals).replace(/\.0$/, '') + 'M';
  if (abs >= 1_000)         return (n / 1_000).toFixed(decimals).replace(/\.0$/, '') + 'K';
  if (abs >= 100)           return n.toFixed(0);
  return n.toFixed(decimals).replace(/\.0$/, '');
}

export function money(n, { lang = 'en', decimals = 1 } = {}) {
  const v = compact(n, { decimals });
  if (v === '—') return v;
  return lang === 'ar' ? `${v} ر.س` : `${v} SAR`;
}

export function pct(n, { decimals = 1 } = {}) {
  if (n === null || n === undefined || isNaN(n)) return '—';
  // Accept both 0.94 and 94 — heuristic
  const v = n <= 1.5 ? n * 100 : n;
  return `${v.toFixed(decimals).replace(/\.0$/, '')}%`;
}
